import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Navigation.css';

const Navigation = ({ websiteType, userInfo, onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const getNavigationItems = () => {
    switch (websiteType) {
      case 'customer':
        return [
          { path: '/', label: 'Home' },
          { path: '/menu', label: 'Menu' },
          { path: '/cart', label: 'Cart' },
          { path: '/orders', label: 'My Orders' },
        ];
      case 'vendor':
        return [
          { path: '/dashboard', label: 'Dashboard' },
          { path: '/orders', label: 'Orders' },
          { path: '/inventory', label: 'Inventory' },
          { path: '/analytics', label: 'Analytics' },
        ];
      case 'rider':
        return [
          { path: '/dashboard', label: 'Dashboard' },
          { path: '/orders', label: 'Deliveries' },
          { path: '/earnings', label: 'Earnings' },
          { path: '/profile', label: 'Profile' },
        ];
      default:
        return [];
    }
  };

  const getWebsiteTitle = () => '';

  const navigationItems = getNavigationItems();

  const shouldShowBack = () => {
    const path = location.pathname || '';
    return path === '/orders' || path.startsWith('/order/');
  };

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/menu');
    }
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-brand">
          <Link to="/" className="nav-logo" onClick={closeMobileMenu}>
            <img src="https://akuoggticrcsctgkerfl.supabase.co/storage/v1/object/public/public-images/Screenshot_2025-11-20_005401__1_-removebg-preview.png" alt="Company logo" height="50" />
          </Link>
        </div>

        {/* Mobile back button for Orders and Track screens */}
        {shouldShowBack() && (
          <button
            className="nav-back"
            onClick={handleBack}
            aria-label="Go back"
          >
            ←
          </button>
        )}
        
        {/* Desktop Navigation */}
        <div className="nav-menu">
          {navigationItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className="mobile-menu-toggle" 
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          {isMobileMenuOpen ? '✕' : '☰'}
        </button>

        <div className="nav-user">
          {userInfo ? (
            <div className="user-info">
              <span className="user-name">Welcome, {userInfo.name}</span>
              <button onClick={onLogout} className="logout-btn">
                Logout
              </button>
            </div>
          ) : (
            <Link to="/login" className="login-btn" onClick={closeMobileMenu}>
              Login
            </Link>
          )}
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
        {navigationItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            {item.label}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default Navigation;
